import entries from 'lodash/entries';
import isArray from 'lodash/isArray';
import isObject from 'lodash/isObject';

const sensitiveKeys = ['password'];

const maxDepth = 10;

export const filterSensitive = (obj, depth = 0) => {
  const nextDepth = depth + 1;
  if (nextDepth > maxDepth) {
    return obj;
  }
  return entries(obj).reduce((acc, [key, value]) => {
    if (sensitiveKeys.includes(key)) {
      return { ...acc, [key]: '[filtered in beagly app]' };
    }
    let nextValue = value;
    if (isArray(value)) {
      nextValue = value.map((current) => filterSensitive(current, nextDepth));
    } else if (isObject(value)) {
      nextValue = filterSensitive(value, nextDepth);
    }
    return { ...acc, [key]: nextValue };
  }, {});
};
